import { Component, Input, OnInit } from "@angular/core";
import * as moment from "moment";
import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
import { PowerTrainService } from "../../../app/services/powertrain.service";
import * as CanvasJS from "./canvasjs.stock.min";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { CommonModule } from "@angular/common";
import { BackendApiService } from "../../../app/services/backend-api.service";

@Component({
  selector: "app-powertrain-healthbar",
  templateUrl: "./powertrain-healthbar.component.html",
  styleUrls: ["./powertrain-healthbar.component.scss"],
  standalone:true,
  imports:[CommonModule]
})
export class PowertrainHealthbarComponent implements OnInit {
  powertrainHealthBarUrl = BaseUrlConstantsService.POWERTRAIN_HEALTH_BAR_API;

  @Input("asset_ids") asset_ids: string[] = [];
  @Input("mac_addresses") mac_addresses: string[] = [];
  @Input("client_id") client_id: string[] = [];
  @Input("type1Devices") type1Devices: [] = [];
  @Input("type2Devices") type2Devices: [] = [];
  @Input("type3Devices") type3Devices: [] = [];
  @Input("type4Devices") type4Devices: [] = [];

  public stackvelocitychartLoader = false;
  public stackvelocitychartErr = "";
  public stackData: any[];

  constructor(private service: PowerTrainService,
    private backendservice: BackendApiService
  ) {}

  ngOnInit(): void {
    this.fetchMachineHealthbar();
  }

  fetchMachineHealthbar() {

     this.stackData = [];
    let interval = 30;
    console.log('--------------------------------------')
    this.stackvelocitychartLoader = true;
    const deviceParams = {
      type1: this.type1Devices,
      type2: this.type2Devices,
      type3: this.type3Devices,
      type4: this.type4Devices
    };
    let url = `${this.powertrainHealthBarUrl}/${this.client_id}/${interval}/12`;
// Loop through each type and append only if non-empty


console.log('Final URL:', url);
    this.backendservice
  .postData(`${url}`, deviceParams)
  .then((res: any) => {
        console.log(res,'------------------------------')
         if (JSON.parse(JSON.stringify(res)).status == "success") {
                      let resdata = JSON.parse(JSON.stringify(res)).machineHealthData;
                      // delete resdata[0];
        
                      for (let i = 1; i < resdata.length-1 ; i++) {
                        // let testDateUtc = moment.utc(resdata[i].bucket_date).toDate();
                        let timeUpdatedAt = resdata[i].timestamp;
        
                        // new ConvertDatetimePipe().convertDateTime(
                        //   testDateUtc
                        // );
                        // console.log(resdata[i].bucket_date +  "=>" + testDateUtc + "=>" + timeUpdatedAt);
                        let dateandtime = timeUpdatedAt.split(" ");
                        let date = dateandtime[0].toString();
                        let time = dateandtime[1].toString();
                        
                        let velocityStatus = resdata[i].vibration_err_status || "N/A";
                        let temperatureStatus = resdata[i].temp_err_status || "N/A";
                        let ultrasoundStatus = resdata[i].ultrasound_err_status || "N/A";
                        switch(resdata[i].status) {
                          case 'HEALTHY':
                            this.stackData.push({
                              type: "stackedBar",
                              xValueFormatString: time,
                              color: "#72FF13",
                              dataPoints: [{
                                x: 0,
                                y: 30,
                                time: time,
                                status: resdata[i].status,
                                velocityStatus: velocityStatus,
                                temperatureStatus: temperatureStatus,
                                ultrasoundStatus: ultrasoundStatus
                              }],
                            })
                            break;
                          case 'UNSATISFACTORY':
                            this.stackData.push({
                              type: "stackedBar",
                              xValueFormatString: time,
                              color: "#FAA700",
                              dataPoints: [{
                                x: 0,
                                y: 30,
                                time: time,
                                status: resdata[i].status,
                                velocityStatus: velocityStatus,
                                temperatureStatus: temperatureStatus,
                                ultrasoundStatus: ultrasoundStatus
                              }],
                            })
                            break;
                          case 'UNACCEPTABLE':
                            this.stackData.push({
                              type: "stackedBar",
                              xValueFormatString: time,
                              color: "#ff2a1b",
                              dataPoints: [{
                                x: 0,
                                y: 30,
                                time: time,
                                status: resdata[i].status,
                                velocityStatus: velocityStatus,
                                temperatureStatus: temperatureStatus,
                                ultrasoundStatus: ultrasoundStatus
                              }],
                            })
                            break;
                            case 'IDLE':
                            this.stackData.push({
                              type: "stackedBar",
                              xValueFormatString: time,
                              color: "#cecece",
                              dataPoints: [{
                                x: 0,
                                y: 30,
                                time: time,
                                status: resdata[i].status,
                                velocityStatus: velocityStatus,
                                temperatureStatus: temperatureStatus,
                                ultrasoundStatus: ultrasoundStatus
                              }],
                            })
                            break;
                            case 'OFFLINE':
                            this.stackData.push({
                              type: "stackedBar",
                              xValueFormatString: time,
                              color: "#999999",
                              dataPoints: [{
                                x: 0,
                                y: 30,
                                time: time,
                                status: resdata[i].status,
                                velocityStatus: velocityStatus,
                                temperatureStatus: temperatureStatus,
                                ultrasoundStatus: ultrasoundStatus
                              }],
                            })
                            break;
                          default:
                            this.stackData.push({
                              type: "stackedBar",
                              xValueFormatString: time,
                              color: "#999999",
                              dataPoints: [{
                                x: 0,
                                y: 30,
                                time: time,
                                velocityStatus: velocityStatus,
                                temperatureStatus: temperatureStatus,
                                ultrasoundStatus: ultrasoundStatus
                              }],
                            })
                            break;
                        }
                      }
                      // console.log("Stack data")
                      // console.log(this.stackData)
                      // console.log(this.stackData.length)
                      const chart11 = new CanvasJS.Chart(
                        "stackvelocitychartContainer",
                        {
                          axisX: {
                            valueFormatString: " ",
                            titleFontSize: 100,
                            gridThickness: 0,
                            lineThickness: 0,
                            tickThickness: 0,
                          },
                          axisY: {
                            titleFontSize: 135,
                            valueFormatString: " ",
                            gridThickness: 0,
                            lineThickness: 0,
                            tickThickness: 0,
                          },
                          toolTip: {
                            contentFormatter: function(e) {
                              const dataPoint = e.entries[0].dataPoint;
        
                              // Helper function to get status color
                              function getStatusColor(status) {
                                switch(status) {
                                  case 'HEALTHY': return "#72FF13"; // Green
                                  case 'UNSATISFACTORY': return "#FAA700"; // Orange/Amber
                                  case 'UNACCEPTABLE': return "#ff2a1b"; // Red
                                  case 'IDLE': return "#cecece"; // idle
                                  default: return "#999999";         // Gray for unknown/undefined
                                }
                              }
        
                              // Color formatting for each status
                              const velocityColor = getStatusColor(dataPoint.velocityStatus);
                              const temperatureColor = getStatusColor(dataPoint.temperatureStatus);
                              const ultrasoundColor = getStatusColor(dataPoint.ultrasoundStatus);
        
                              return `<div style="padding: 5px;">
                                <b>Time:</b> ${dataPoint.time}<br/>
                                <b>Status:</b> ${dataPoint.status}<br/>
                                <b>Velocity:</b> <span style="color:${velocityColor}; font-weight:bold">${dataPoint.velocityStatus}</span><br/>
                                <b>Temperature:</b> <span style="color:${temperatureColor}; font-weight:bold">${dataPoint.temperatureStatus}</span><br/>
                                <b>Ultrasound:</b> <span style="color:${ultrasoundColor}; font-weight:bold">${dataPoint.ultrasoundStatus}</span>
                              </div>`;
                            },
                            shared: false,
                          },
                          dataPointWidth: 65,
        
                          data: this.stackData,
                          afterRender: function () {
                            this.stackvelocitychartLoader = false;
                          },
                        }
                      );
                      setTimeout(() => {
                        console.log('rendering chart...')
                        if(chart11) chart11.render();
                      }, 200);
                      // chart11.render();
                      this.stackvelocitychartLoader = false;
                    } else {
                    }
      })
      .catch((err) => {
        console.log(err);
        this.stackvelocitychartErr = "No Data Available";
      })
      .finally(() => {
        this.stackvelocitychartLoader = false;
      });
  }
}
